import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

/**
 * PhoneField — internationally-aware phone input wrapping react-phone-input-2.
 *
 * Returns the full E.164 number (e.g. "+96891234567") via `onChange(value)`.
 * Country can be preselected with `defaultCountry` (ISO2 lowercase, e.g. "om").
 * RTL safe: the dial-code picker is left-aligned and the digits are always LTR.
 */
export default function PhoneField({
    value,
    onChange,
    defaultCountry = "om",
    disabled = false,
    placeholder = "9XXXXXXXX",
    testId = "phone-input",
    autoFocus = false,
}) {
    return (
        <div data-testid={testId} className="phone-field-wrap">
            <PhoneInput
                country={defaultCountry}
                value={value || ""}
                onChange={(v) => onChange?.(v ? `+${v.replace(/^\+/, "")}` : "")}
                disabled={disabled}
                enableSearch
                disableSearchIcon
                searchPlaceholder="ابحث عن الدولة"
                placeholder={placeholder}
                inputProps={{
                    name: "phone",
                    autoFocus,
                    dir: "ltr",
                    autoComplete: "tel",
                    "data-testid": `${testId}-input`,
                }}
                buttonClass="!h-12 !rounded-s-lg !border !border-neutral-300 !bg-white"
                inputClass="!h-12 !w-full !rounded-s-none !rounded-e-lg !border !border-neutral-300 !bg-white !pe-3 !ps-14 !font-numbers !text-base"
                containerClass="!w-full"
                dropdownClass="!text-sm"
            />
        </div>
    );
}
